import { useState, useCallback } from 'react';

export const useMergeState = (initialState) => {
  const [value, setValue] = useState(initialState);

  const mergeState = useCallback((newState) => {
    let newStateTemp = newState;

    setValue(draft => {
      if (typeof newState === 'function')
        newStateTemp = newState(draft);

      return ({ ...draft, ...newStateTemp });
    });
  }, [value]);

  return [value, mergeState];
};

export default useMergeState;
